module.exports = __webpack_public_path__ + "img/dr_good_vol23.0c4ffabd.jpg";